import {
    Card, Carousel, Image, Popover, theme, Typography,
} from 'antd';
import { useNavigate } from 'react-router-dom';

import { Script } from '@/types';
import { stripHtml } from '@/utils';

import { ImagePlaceholder } from './ImagePlaceholder';

type CrossSellsCarouselProps = {
    scripts: Script[];
};

export const CrossSellsCarousel = ({ scripts }: CrossSellsCarouselProps) => {
    const { token } = theme.useToken();
    const navigate = useNavigate();

    if (!scripts || scripts.length === 0) {
        return null;
    }

    if (scripts.length < 4) {
        return (
            <Card
                title="Крос-сейли"
                size="small"
                className="similar-scripts-card"
                style={{
                    background: token.colorFillTertiary,
                    borderColor: token.colorBorderSecondary,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        gap: token.margin,
                        flexWrap: 'wrap',
                        justifyContent: scripts.length <= 2 ? 'center' : 'flex-start',
                    }}
                >
                    {scripts.map((script) => (
                        <Card
                            key={script.id}
                            size="small"
                            style={{
                                width: 200,
                                cursor: 'pointer',
                                height: 'auto',
                            }}
                            onClick={() => {
                                if (script.project_id) {
                                    navigate(`/projects/${script.project_id}/scripts/${script.id}`);
                                }
                            }}
                            cover={
                                <Popover
                                    trigger="hover"
                                    title={script.title}
                                    content={stripHtml(script.description)}
                                    styles={{
                                        root: {
                                            maxWidth: "600px",
                                        }
                                    }}
                                >
                                    {script.main_image?.thumb ? (
                                        <Image
                                            src={script.main_image.thumb}
                                            alt={script.title}
                                            preview={false}
                                            style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }}
                                        />
                                    ) : (
                                        <div style={{ width: '100%', height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <ImagePlaceholder width={120} height={120} />
                                        </div>
                                    )}
                                </Popover>
                            }
                        >
                            <Typography.Text
                                strong
                                ellipsis
                                style={{ display: 'block', marginBottom: 4 }}
                            >
                                {script.title}
                            </Typography.Text>
                            <div style={{ display: 'block', marginBottom: script.product_id ? 4 : 0 }}>
                                <Typography.Text type="secondary">Ціна: </Typography.Text>
                                <Typography.Text strong>
                                    {script.product_price}
                                </Typography.Text>
                            </div>
                            {script.product_id && (
                                <div style={{ display: 'block' }}>
                                    <Typography.Text type="secondary">ID продукту: </Typography.Text>
                                    <Typography.Text strong>
                                        {script.product_id}
                                    </Typography.Text>
                                </div>
                            )}
                        </Card>
                    ))}
                </div>
            </Card>
        );
    }

    return (
        <Card
            title="Крос-сейли"
            size="small"
            className="similar-scripts-card"
            style={{
                background: token.colorFillTertiary,
                borderColor: token.colorBorderSecondary,
            }}
        >
            <div className="similar-scripts-card--gallery" style={{ maxWidth: 650 }}>
                <Carousel
                    dots={true}
                    arrows={true}
                    draggable={true}
                    slidesToShow={4}
                    slidesToScroll={1}
                    infinite={false}
                >
                    {scripts.map((script) => (
                        <div key={script.id} style={{
                            height: '100%',
                        }}>
                            <div style={{ padding: `0 ${token.paddingXXS}px` }}>
                                <Card
                                    size="small"
                                    style={{
                                        width: 200,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        if (script.project_id) {
                                            navigate(`/projects/${script.project_id}/scripts/${script.id}`);
                                        }
                                    }}
                                    cover={
                                        <Popover
                                            trigger="hover"
                                            title={script.title}
                                            content={stripHtml(script.description)}
                                            styles={{
                                                root: {
                                                    maxWidth: "600px",
                                                }
                                            }}
                                        >
                                            {script.main_image?.thumb ? (
                                                <Image
                                                    src={script.main_image.thumb}
                                                    alt={script.title}
                                                    preview={false}
                                                    style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }}
                                                />
                                            ) : (
                                                <div style={{ width: '100%', height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <ImagePlaceholder width={150} height={100} />
                                                </div>
                                            )}
                                        </Popover>
                                    }
                                >
                                    <Typography.Text
                                        strong
                                        ellipsis
                                        style={{ display: 'block', marginBottom: 4 }}
                                    >
                                        {script.title}
                                    </Typography.Text>
                                    {script.product_id && (
                                        <div style={{ display: 'block', marginBottom: 4 }}>
                                            <Typography.Text type="secondary">ID продукту: </Typography.Text>
                                            <Typography.Text strong>
                                                {script.product_id}
                                            </Typography.Text>
                                        </div>
                                    )}
                                    <div style={{ display: 'block' }}>
                                        <Typography.Text type="secondary">Ціна: </Typography.Text>
                                        <Typography.Text strong>
                                            {script.product_price}
                                        </Typography.Text>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </Card>
    );
};
